import styled from "styled-components";

export const ToggleButton = styled.button<{ $themeName: "light" | "dark" }>`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  width: 58px;
  height: 34px;
  padding: 0 8px;
  border: 1px solid ${({ theme }) => theme.colors.inputBorder};
  border-radius: 999px;
  background: ${({ $themeName, theme }) =>
    $themeName === "dark" ? "#93c5fd29" : theme.colors.lightGrey};
  color: ${({ $themeName, theme }) =>
    $themeName === "dark"
      ? theme.colors.secondary
      : theme.colors.iconSecondary};
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    box-shadow: ${({ theme }) => theme.shadow.medium};
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 0.2rem ${({ theme }) => theme.colors.primary};
  }

  i {
    position: relative;
    z-index: 1;
    font-size: 1rem;
    line-height: 1;
    opacity: 0.75;
    transition: color 0.2s ease, opacity 0.2s ease;
  }

  .pi-sun {
    color: ${({ $themeName, theme }) =>
      $themeName === "light"
        ? theme.colors.secondary
        : theme.colors.mediumGrey};
    opacity: ${({ $themeName }) => ($themeName === "light" ? 1 : 0.45)};
  }

  .pi-moon {
    color: ${({ $themeName, theme }) =>
      $themeName === "dark" ? theme.colors.secondary : theme.colors.mediumGrey};
    opacity: ${({ $themeName }) => ($themeName === "dark" ? 1 : 0.45)};
  }

  &::after {
    content: "";
    position: absolute;
    z-index: 0;
    top: 3px;
    left: ${({ $themeName }) => ($themeName === "dark" ? "26px" : "3px")};
    width: 26px;
    height: 26px;
    border-radius: 50%;
    background: ${({ theme }) => theme.colors.background};
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.22);
    transition: left 0.2s ease, background 0.2s ease;
  }
`;
